var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 21.829,
    viewBox: "0 0 30 21.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cloud-computing",
    transform: "translate(0 -66.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(0 66.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M23.441,88.479H17v-6.5h2.127a.665.665,0,0,0,.539-1.054L15.533,75.2a.659.659,0,0,0-1.073,0l-4.138,5.725a.664.664,0,0,0,.539,1.054h2.127v6.5H5.781A6.447,6.447,0,0,1,0,82.03a6.107,6.107,0,0,1,3.028-5.272,4.094,4.094,0,0,1-.251-1.428,4.152,4.152,0,0,1,4.156-4.156,4.085,4.085,0,0,1,1.422.251,8.32,8.32,0,0,1,15.809,2.746,7.238,7.238,0,0,1-.723,14.307Z",
    transform: "translate(0 -66.65)",
    fill: "#072430"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.c79947ab2373107825665c7b866cce2a.svg";
export { ForwardRef as ReactComponent };